const AlreadySubmittedPage = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2>Thank You! This form has already been submitted.</h2>
      <p>You have already completed this reference questionnaire.</p>
      <p>
        If you believe this is a mistake, please contact{" "}
        <a href="mailto:request@oxforddoc.com">request@oxforddoc.com</a>.
      </p>
    </div>
  );
};

export default AlreadySubmittedPage;
